<!-- Header -->
@if(isLoggedIn()) {
  <header class="d-print-none">
    <div class="row">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="col col-md-7 col-12">
            <kp-logo></kp-logo>

            @if(selectedUserFullName()) {
              <div class="env-wrapper d-none d-md-inline-block" style="vertical-align:top;">
                <div class="env bg-secondary">
                  Vald säljare: {{selectedUserFullName()}}
                </div>
              </div>
            }

            @if(axEnv() !== 'PROD') {
              <div class="env-wrapper d-none d-md-inline-block" style="vertical-align:top;">
                <div class="env bg-warning" [ngClass]="{'pointer' : reloadForMfStyles()}" (click)="addMfDomainParam()" [tooltip]="(reloadForMfStyles() ? 'Klicka för att byta till mf-stylesheet' : '')">
                  @switch (axEnv()) {
                    @case ('DEV_LOCAL') {
                      Miljö: Dev (local)
                    }
                    @case ('DEBUG_LOCAL') {
                      Miljö: Debug (local)
                    }
                    @case ('D1_DEV') {
                      Miljö: Debug D1
                    }
                    @case ('MDEV_LOCAL') {
                      Miljö: Debug MDEV (local)
                    }
                    @case ('ACC_LOCAL') {
                      Miljö: Acceptans (local)
                    }
                    @case ('DEV') {
                      Miljö: DEV
                    }
                    @case ('TEST') {
                      Miljö: TEST
                    }
                    @case ('ACC') {
                      Miljö: Acceptans
                    }
                    @case ('MDEV') {
                      Miljö: MDEV
                    }
                    @case ('MTEST') {
                      Miljö: MTEST
                    }
                  }
                </div>
              </div>
            }

            <nav class="navbar navbar-expand-md navbar-dark navbar-right">
                <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#header-nav" aria-controls="header-nav">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </nav>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="col-md-5 col-12">
          <top-nav></top-nav>
        </div>

    </div>
    <div class="header-background"></div>

  </header>
}
